var Slot = /*@__PURE__*/ (function () {
    function Slot(index, label) {
        var _this = this;
        this.remove = function () {
            jQuery(_this.element).remove();
        };
        this.activate = function () {
            _this.active = true;
            jQuery(_this.element).addClass(Slot.ACTIVE_CLASS);
        };
        this.deactivate = function () {
            _this.active = false;
            jQuery(_this.element).removeClass(Slot.ACTIVE_CLASS);
        };
        this.enable = function () {
            _this.enabled = true;
            jQuery(_this.element).removeClass(Slot.DISABLED_CLASS);
        };
        this.disable = function () {
            _this.enabled = false;
            jQuery(_this.element).addClass(Slot.DISABLED_CLASS);
        };
        this.getElement = function () {
            return _this.element;
        };
        this.onClick = function (callback) {
            _this.clickEvt = callback;
            jQuery(_this.element).on('click', function () {
                _this.clickEvt(_this.index, _this.label);
            });
        };
        this.element = jQuery(Slot.HTML).html(label).get(0);
        this.active = false;
        this.enabled = true;
        this.index = index;
        this.label = label;
    }
    Slot.HTML = "<div class=\"slot\"></div>";
    Slot.ACTIVE_CLASS = 'active';
    Slot.DISABLED_CLASS = 'disabled';
    return Slot;
}());
export default Slot;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/TimeTable/Slot.ts
// module id = null
// module chunks = 